<template>
  <div class="attach-file">
    <p>Bước 2</p>
    <h1>Hình ảnh xác minh</h1>

    <!-- UPLOAD IMAGE -->

    <div
      class="upload-avt upload-zone"
      @click="openUploadModal(imageKeys.AVATAR)"
      title="Ấn vào để thay ảnh"
    >
      <div
        class="content-avt content--upload_zone"
        v-if="supplier_avatar === '' || supplier_avatar === undefined || supplier_avatar === null"
      >
        <img src="/img/icons/user-info.svg" width="32" height="32" alt="user-info" />
        <p>{{$t('driver_onboarding.attach_file.avatar')}}</p>
      </div>
      <div v-else class="supplier-avatar">
        <img width="120" height="120" :src="supplier_avatar" :alt="`${supplierId}_avatar`" />
        <div class="layer">
          <span>{{$t('driver_onboarding.attach_file.change_image')}}</span>
        </div>
      </div>
    </div>

    <div class="upload-id">
      <span>{{$t('driver_onboarding.attach_file.identification')}}</span>
      <div class="identity-card is-flex">
        <div class="ic-frontcard upload-zone" @click="openUploadModal(imageKeys.FRONTSIDE)">
          <div class="content--upload_zone" :style="imageStyles[imageKeys.FRONTSIDE]" @change="checkData">
            <div v-if="!selectedImages[imageKeys.FRONTSIDE]">
              <img src="/img/icons/frontcard.svg" width="42" height="24" alt />
              <p>{{$t('driver_onboarding.attach_file.front_side')}}</p>
            </div>
            <div v-else class="layer">
              <span>{{$t('driver_onboarding.attach_file.change_image')}}</span>
            </div>
          </div>
        </div>

        <div class="ic-backcard upload-zone" @click="openUploadModal(imageKeys.BACKSIDE)">
          <div class="content--upload_zone" :style="imageStyles[imageKeys.BACKSIDE]">
            <div v-if="!selectedImages[imageKeys.BACKSIDE]">
              <img src="/img/icons/backcard.svg" width="42" height="24" alt="user-info" />

              <p>{{$t('driver_onboarding.attach_file.back_side')}}</p>
            </div>
            <div v-else class="layer">
              <span>{{$t('driver_onboarding.attach_file.change_image')}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="upload-id">
      <span>{{$t('driver_onboarding.attach_file.family_address')}}</span>
      <div class="identity-card is-flex">
        <div class="ic-frontcard upload-zone" @click="openUploadModal(imageKeys.FRONT_FAMILY)">
          <div class="content--upload_zone" :style="imageStyles[imageKeys.FRONT_FAMILY]">
            <div v-if="!selectedImages[imageKeys.FRONT_FAMILY]">
              <img src="/img/icons/front-family.svg" width="42" height="24" alt />
              <p>{{$t('driver_onboarding.attach_file.front_family_address')}}</p>
            </div>
            <div v-else class="layer">
              <span>{{$t('driver_onboarding.attach_file.change_image')}}</span>
            </div>
          </div>
        </div>

        <div class="ic-backcard upload-zone" @click="openUploadModal(imageKeys.BACK_FAMILY)">
          <div class="content--upload_zone" :style="imageStyles[imageKeys.BACK_FAMILY]">
            <div v-if="!selectedImages[imageKeys.BACK_FAMILY]">
              <img src="/img/icons/back-family.svg" width="42" height="24" alt="user-info" />

              <p>{{$t('driver_onboarding.attach_file.info_family_address')}}</p>
            </div>
            <div v-else class="layer">
              <span>{{$t('driver_onboarding.attach_file.change_image')}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="upload-id">
      <span>{{$t('driver_onboarding.attach_file.another_image')}} (Không bắt buộc)</span>
      <div class="identity-card is-flex">
        <div class="ic-frontcard upload-zone" @click="openUploadModal(imageKeys.OTHER_1)">
          <div class="content--upload_zone" :style="imageStyles[imageKeys.OTHER_1]">
            <div v-if="!selectedImages[imageKeys.OTHER_1]">
              <img src="/img/icons/picture.svg" width="42" height="24" alt />
              <p>{{$t('driver_onboarding.attach_file.another_image')}}</p>
            </div>
            <div v-else class="layer">
              <span>{{$t('driver_onboarding.attach_file.change_image')}}</span>
            </div>
          </div>
        </div>
        <div class="ic-backcard upload-zone" @click="openUploadModal(imageKeys.OTHER_2)">
          <div class="content--upload_zone" :style="imageStyles[imageKeys.OTHER_2]">
            <div v-if="!selectedImages[imageKeys.OTHER_2]">
              <img src="/img/icons/picture.svg" width="42" height="24" alt="user-info" />
              <p>{{$t('driver_onboarding.attach_file.another_image')}}</p>
            </div>
            <div v-else class="layer">
              <span>{{$t('driver_onboarding.attach_file.change_image')}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- END UPLOAD -->
    <UploadImgModal ref="uploadImgModal" @addImage="addImage" @onChangeAvatar="handleGetAvatar" @changeUploadingImg="onChangeUploading" />

    <b-button @click.prevent="onSubmit" :disabled="loading">Tiếp tục</b-button>
  </div>
</template>
<script>
import UploadImgModal from "./UploadImgModal";
import { mapGetters } from "vuex";
import Vue from "vue";
const { API } = Vue.prototype.$constants;

const IMAGE_KEYS = {
  FRONTSIDE: "f",
  BACKSIDE: "b",
  FRONT_FAMILY: "ff",
  BACK_FAMILY: "bf",
  AVATAR: "a",
  OTHER_1: "others_1",
  OTHER_2: "others_2"
};

const LINK_IMAGE = {
  AVATAR: `${process.env.VUE_APP_API_URL}${API.supplier.file}?file_id=avatar&size=128&clear_cache=true&version=-1`
};

export default {
  data() {
    return {
      loading: true,
      uploadingImages: {},
      selectedImages: {},
      displayImages: {},
      imageKeys: IMAGE_KEYS,
      uploadIndex: "",
      supplier_avatar: "",
      supplier_card_front: ""
    };
  },
  computed: {
    ...mapGetters(["supplierToken", "supplierProfile", 'nextStepButtonVisible']),
    supplierId() {
      return this.supplierProfile && this.supplierProfile._id;
    },
    imageStyles: {
      cache: false,
      get() {
        let result = {};
        for (let key in IMAGE_KEYS) {
          const index = IMAGE_KEYS[key];
          let imgUrl = this.displayImages[index] || this.selectedImages[index]
          if(imgUrl) {
            imgUrl = `url(${imgUrl})`

            result[index] = {
              backgroundImage: imgUrl,
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              position: "absolute",
              top: 0,
              left: 0,
              margin: 0,
              width: "100%",
              borderRadius: "8px"
            }
          }else{
            result[index] = {}
          }
        }
        this.checkData()
        return result;
      }
    },
    
    fileNames() {
      const ext = ".jpg";
      const supplierId = this.supplierId;
      let result = {
        [IMAGE_KEYS.FRONTSIDE]: `id_card_front_${supplierId}${ext}`,
        [IMAGE_KEYS.BACKSIDE]: `id_card_back_${supplierId}${ext}`,
        [IMAGE_KEYS.FRONT_FAMILY]: `family_register_front_${supplierId}${ext}`,
        [IMAGE_KEYS.BACK_FAMILY]: `family_register_back_${supplierId}${ext}`,
        [IMAGE_KEYS.OTHER_1]: `others_1_${supplierId}${ext}`,
        [IMAGE_KEYS.OTHER_2]: `others_2_${supplierId}${ext}`
      };
      return result;
    }
  },
  components: {
    UploadImgModal
  },
  methods: {
    checkData() {
     if(this.selectedImages && this.selectedImages.f && this.selectedImages.b && this.selectedImages.ff && this.selectedImages.bf){
        this.loading = false
      }
    },
    onSubmit() {
      if (!this.loading) {
        this.$router.push({ name: "profile" });
      }

      this.$gtag('event',this.$trackingEvents.EVENTS.SUBMIT_UPLOAD, {'event_category' : this.$route.path})

    },

    openUploadModal(index) {
      if (this.$refs.uploadImgModal.imgSrc !== null) {
        this.$refs.uploadImgModal.imgSrc = null;
      }
      this.$refs.uploadImgModal.imgType = index;
      this.uploadIndex = index;
      this.$refs.uploadImgModal.showDialogUpload = true;
    },

    addImage(index, image) {
      this.selectedImages[index] = image;
      // this.supplier_card_front = image;
      this.checkData()
      this.$forceUpdate();
    },

    onChangeUploading(index, image){
      if(image && image !== ''){
        this.displayImages[index] = image
      }
    },

    handleGetAvatar() {
      let data = {
        token: this.supplierToken,
        id: this.supplierId,
        file_id: "avatar",
        clear_cache: true,
        size: 128,
        version: -1,
        time: new Date().getTime()
      };

      this.$store
        .dispatch("getAvatar", data)
        .then(response => {
          if (response && response.status === 200) {
            this.supplier_avatar = `${LINK_IMAGE.AVATAR}&token=${data.token}&id=${data.id}&time=${data.time}`;
          }
        })
        .catch(error => {
          // console.log("error handleGetAvatar", error);
          if (error) {
            if(error.status !== 404) {
              this.$buefy.notification.open({
                message: error.data.description,
                type: "is-danger",
                duration: 3000,
                position: "is-bottom"
              });
            }
            if(error.status === 404) {
              this.$store.dispatch('supplierLogOut', this.supplierToken).then(response => {
                if(response && response.status === 200) {
                  if(this.getCookie('timer')){
                    this.$deleteCookie('timer');
                  }
                  this.$router.push({name : 'signin'})
                  this.$buefy.notification.open({
                    message: this.$t("driver_onboarding.logout_success"),
                    type: "is-success",
                    duration: 3000,
                    position: "is-bottom"
                  });
                }
              })
            }
          }
        });
    },

    imageExists(url, key) {
      return new Promise((resolve, reject) => {
        var image = new Image();
        image.onload = function() {
          resolve({
            key: key,
            url: url
          });
        };
        image.onerror = function() {
          reject();
        };
        image.src = url;
      });
    },

    checkSubmitFormHistory() {
      const baseUrl = process.env.VUE_APP_ADMIN_SPACE_URL;
        for (var key in this.fileNames) {
          let name = this.fileNames[key];
          const url = baseUrl.concat("/", name);
          this.imageExists(url, key).then(data => {
            this.selectedImages[data.key] = data.url;
            this.$forceUpdate();
          });
        }
        this.checkData()
    }
  },
  beforeMount() {
    this.checkSubmitFormHistory();
    this.handleGetAvatar();
    if(this.supplierProfile && this.supplierProfile.extra && (this.supplierProfile.extra.is_valid || this.supplierProfile.extra.is_contracted)){
      this.$router.push({name : 'training'})
    }
  },
};
</script>
<style lang="scss" scoped>
.attach-file {
  p:first-child {
    color: #bcbcbc;
    font-size: 16px;
    margin-bottom: 4px;
    font-weight: 500;
  }
  h1 {
    margin: 0 0 40px 0;
    color: #1a1a1a;
  }

  .upload-avt {
    width: 120px;
    height: 120px;

    &:hover {
      background-color: #fff;
      border: 1px solid #ff8200;
      cursor: pointer;
    }

    .supplier-avatar {
      position: relative;
      border-radius: 8px;
      overflow: hidden;

      &:hover {
        .layer {
          bottom: 5px;
        }
      }

      img {
        border-radius: 8px;
        z-index: 1;
      }
      .layer {
        position: absolute;
        height: 60px;
        bottom: -60px;
        padding: 15px 0;
        width: 100%;
        text-align: center;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        transition: all 0.3s;
        background-color: rgba(0, 0, 0, 0.65);

        span {
          color: #fff;
          margin: 3px 2px;
          font-weight: 500;
        }
      }
    }
  }

  .upload-id {
    margin-top: 24px;

    span {
      font-weight: 500;
    }
    .identity-card {
      margin-top: 10px;

      .ic-frontcard {
        margin-right: 12px;
      }

      .ic-frontcard,
      .ic-backcard {
        width: 180px;
        height: 112px;
        overflow: hidden;
        &:hover {
          background-color: #fff;
          border: 1px solid #ff8200;
          cursor: pointer;

          .layer {
            // display: block;
            bottom: 0;
          }
        }

        .layer {
          position: absolute;
          height: 56px;
          bottom: -56px;
          padding: 15px 0;
          width: 100%;
          text-align: center;
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
          transition: all 0.3s;
          background-color: rgba(0, 0, 0, 0.65);
          color: #ffffff;
        }
      }
    }
  }

  .upload-zone {
    position: relative;
    border: 1px solid #e7e7e7;
    border-radius: 8px;
    background-color: #fbfbfb;

    .content--upload_zone {
      position: absolute;
      bottom: 0;
      left: 0;
      margin: 0 0 16px 16px;
      p {
        font-size: 14px;
        color: #ff8200;
        font-weight: 500;
      }
    }
  }

  button {
    margin-top: 32px;
    margin-bottom: 32px;
    background-color: #ff8200;
    color: #fff;
    border-color: inherit;
    border-radius: 4px;
    width: 150px;
    height: 48px;
    font-weight: 500;
  }
}
</style>
